import React from 'react';
import p1 from '../../assets/revs/p001.webp';
import p2 from '../../assets/revs/p002.webp';
import p3 from '../../assets/revs/p003.webp';

const About = () => {
  return (
    <section id='about'>
      <div className='container'>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>
          Начните зарабатывать через девять занятий
        </h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          После завершения курсов мы поможем вам со стартом!
        </h4>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <div className='row'>
            <div className='col-lg-7'>
              <div className='card-review first bg-white flex aifs p-4'>
                <img src={p1} alt='Natasha' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Наталья, паспортистка</h4>
                  <p style={{ minHeight: 40, paddingTop: 7 }}>
                    Привет! 
                    Прошла курсы GoIT по направлению "Backend" и ничего не поняла.
                    Потом прошла курс вайб-кодинга и все равно ничего не поняла,
                    но мой код стал работать. Спасибо вам за возможность которую предоставили мне!
                  </p>
                </div>
              </div>
              <div className='s-24'></div>
              <div className='card-review second bg-white flex aifs p-4'>
                <img src={p2} alt='Snejana' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Снежана, повариха</h4>
                  <p>
                    Большое спасибо) я больше года не могла найти работу после техникума, а тут
                    переучилась на DevOps и через полтора месяца нашла работу! Это был очень классный опыт) спасибо за все и желаю успехов остальным учащимся!
                  </p>
                </div>
              </div>
              <div className='s-24 d-none-d-sm-block'></div>
            </div>
            <div className='col-lg-5'>
              <div className='card-review third bg-white flex aifs p-4'>
                <img src={p3} alt='Youri' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Юра, сварщик</h4>
                  <div className='s-10'></div>
                  <p style={{ paddingRight: 18 }}>
                    Вот это те самые курсы, которые я искал!
                    Все остальные - сложные, парят мозги и я ничего не соображаю.
                    А тут все просто и понятно. Научился клепать сайты на Next.js как пирожки!
                    Конечно, они не такие красивые, как ожидают заказчики, но зато работают.
                    А главное, что я могу их делать с помощью AI очень быстро!
                    <br />
                    Мой совет будущим учащимся: не идите работать по найму, а сразу начинайте названивать в агенства
                    и впаривать свои услуги. Соглашайтесь на любые условия, главное - получить аванс. Там они уже
                    никуда не денуться! Проверено на себе.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
      </div>
    </section>
  );
};

export { About };
